module.exports = __webpack_public_path__ + "img/extended.ae95c70e.png";